module.exports = __webpack_public_path__ + "img/05_new2017_pr.3ebbf5ad.png";